import { useState } from "react";
import { typeEventCard } from "../../types/eventType";
import { getEventList } from "../../services/eventService";
import React from "react";

const useFooterLogic = () => {
  const [events, setEvents] = useState<typeEventCard[]>([]);

  const fetchEvents = async () => {
    try {
      const response = await getEventList({ limit: 2 });
      setEvents(response.data.data.events);
    } catch (error) {
      console.error("Error fetching events:", error);
      return [];
    }
  };

  React.useEffect(() => {
    fetchEvents();
  }, []);

  const contactDetails = {
    email: "contact@eventluxenj.com",
    address: "123 Hoboken, New Jersey 07030",
    phone: ["+1 (201) 555-0134"],
  };

  return { events, contactDetails };
};

export default useFooterLogic;
